import React from 'react';
import Highlight, { defaultProps } from 'prism-react-renderer';
import classNames from 'classnames';

export const CodeBlock = ({
  children,
  language,
  stripLast = true,
  withMarginBottom = true,
  rounded = true,
  className = '',
  maxHeight = 'auto',
}) => {
  const computedLanguage = className ? className.replace(/language-/, '') : '';

  return (
    <Highlight
      {...defaultProps}
      code={children}
      language={language || computedLanguage}
      theme={{
        plain: {
          color: '#c4d3ff',
          backgroundColor: '#1c1c1f',
        },
        styles: [
          {
            types: ['prolog', 'constant', 'builtin'],
            style: {
              color: 'rgb(189, 147, 249)',
            },
          },
          {
            types: ['inserted', 'function'],
            style: {
              color: '#e7e899',
            },
          },
          {
            types: ['deleted'],
            style: {
              color: 'rgb(255, 85, 85)',
            },
          },
          {
            types: ['changed'],
            style: {
              color: 'rgb(255, 184, 108)',
            },
          },
          {
            types: ['punctuation', 'symbol'],
            style: {
              color: 'rgb(248, 248, 242)',
            },
          },
          {
            types: ['string', 'char', 'tag', 'selector'],
            style: {
              color: '#7ed6a6',
            },
          },
          {
            types: ['keyword', 'variable'],
            style: {
              color: 'rgb(189, 147, 249)',
              fontStyle: 'italic',
            },
          },
          {
            types: ['comment'],
            style: {
              color: 'rgb(98, 114, 164)',
            },
          },
          {
            types: ['attr-name'],
            style: {
              color: '#adc0f9',
            },
          },
          {
            types: ['attr-value'],
            style: {
              color: '#7ed6a6',
            },
          },
          {
            types: ['tag'],
            style: {
              color: '#6086f3',
            },
          },
          {
            types: ['punctuation'],
            style: {
              color: '#868fb3',
            },
          },
        ],
      }}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre
          className={classNames(
            'p-4 shadow-sm overflow-auto leading-5 text-sm',
            className,
            {
              'mb-6': withMarginBottom,
              rounded,
            }
          )}
          style={{ ...style, maxHeight }}
        >
          {tokens.map(
            (line, i) =>
              i !== (stripLast ? tokens.length - 1 : tokens.length) && (
                <div key={i} {...getLineProps({ line, key: i })}>
                  {line.map((token, key) => (
                    <span key={key} {...getTokenProps({ token, key })} />
                  ))}
                </div>
              )
          )}
        </pre>
      )}
    </Highlight>
  );
};
